module.exports = __webpack_public_path__ + "mainassets/img/about-us-2.8140de9d.jpg";